export default function ({ glideBehaviour, perView, startAt, sizingFunction }) {
    let glideConfig = {
        type: glideBehaviour,
        startAt: startAt ?? 0,
        perView: perView ?? 3.55,
        gap: 32,
        peek: {
            after: 275,
            before: 0
        }
    }

    if (glideBehaviour === 'slider') {
        glideConfig.rewind = false
        glideConfig.bound = true
    }

    const viewportSize = document.documentElement.clientWidth
    sizingFunction = sizingFunction || defaultSizingFunction
    const sizeConfig = sizingFunction(viewportSize) || {}
    return Object.assign(glideConfig, sizeConfig)
}

function defaultSizingFunction(viewportSize) {
    if (viewportSize < 400) {
        return {
            perView: 1.15,
            gap: 14,
            peek: {
                after: 50,
                before: 0
            }
        }
    } else if (viewportSize < 500) {
        return {
            perView: 1.45,
            gap: 16,
            peek: {
                after: 50,
                before: 0
            }
        }
    } else if (viewportSize < 700) {
        return {
            perView: 2.1,
            gap: 20,
            peek: {
                after: 75,
                before: 0
            }
        }
    } else if (viewportSize < 800) {
        return {
            perView: 2.9,
            gap: 22,
            peek: {
                after: 70,
                before: 0
            }
        }
    } else if (viewportSize < 1000) {
        return {
            perView: 3.2,
            gap: 32,
            peek: {
                after: 70,
                before: 0
            }
        }
    } else if (viewportSize < 1200) {
        return {
            perView: 3.8,
            gap: 32,
            peek: {
                after: 160,
                before: 0
            }
        }
    } else {
        return null
    }
}
